import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayWhenNull'
})
export class DisplayWhenNullPipe implements PipeTransform {

  transform(value: any, valueToDisplayIfNull: any): any {
    return value == null ? valueToDisplayIfNull : value;
  }

}
